export default __webpack_public_path__ + "static/media/080_finish_good.hevc.88554c27.mp4";